import { ResetPasswordForm } from "@/components/form/ResetPasswordForm";

const ResetPasswordPage = () => {
  return <ResetPasswordForm />;
};

export default ResetPasswordPage;
